import { datadogRum } from '@datadog/browser-rum';
import { SERVER_URL } from 'src/modules/server/const';

export const initialize = () => {
  if (!!process.env.REACT_APP_DATADOG_ENABLED) {
    datadogRum.init({
      applicationId: 'ed00e175-887a-44b1-868c-749dba4fb682',
      clientToken: 'pub9eb12e4cb44375ac4cb2b6565d0a9e69',
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'datadoghq.com',
      service: 'yap',
      env: process.env.REACT_APP_ENV,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      allowedTracingUrls: [ SERVER_URL ],
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: 'mask-user-input',
      trackUserInteractions: true,
      enablePrivacyForActionName: true,
    });
  }
}
